/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Own_Bot_EnrolledInputs */



/**
* | output |
* | --- |
* | "That bot already runs another server." |
*
* @param {Settings_Own_Bot_EnrolledInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const settings_own_bot_enrolled = /** @type {((inputs?: Settings_Own_Bot_EnrolledInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Own_Bot_EnrolledInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот бот уже обслуживает другой сервер.")
	return /** @type {LocalizedString} */ ("That bot already runs another server.")
});